module.exports = __webpack_public_path__ + "img/bespoke123_27.1cd33dee.jpg";